module.exports = __webpack_public_path__ + "static/mathematician-d32ea0f7ee4c4557d2978f206006d762.jpg";